import type { Activity } from "./types"

export const activitiesData: Activity[] = [
  // Communication & Scheduling
  {
    id: "cs1",
    category: "Communication & Scheduling",
    name: "Prioritize and Summarize Daily Emails",
    frequency: "Daily",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 60.8,
  },
  {
    id: "cs2",
    category: "Communication & Scheduling",
    name: "Draft Routine Email Replies",
    frequency: "Daily",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 45.6,
  },
  {
    id: "cs3",
    category: "Communication & Scheduling",
    name: "Schedule Meetings Across Time Zones",
    frequency: "Weekly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 17.3,
  },
  {
    id: "cs4",
    category: "Communication & Scheduling",
    name: "Find and Propose Meeting Times",
    frequency: "Weekly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 8.7,
  },
  {
    id: "cs5",
    category: "Communication & Scheduling",
    name: "Reschedule Appointments and Meetings",
    frequency: "Monthly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 3.0,
  },
  {
    id: "cs6",
    category: "Communication & Scheduling",
    name: "Send Follow-Up Notes After Meetings",
    frequency: "Weekly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 13.0,
  },
  {
    id: "cs7",
    category: "Communication & Scheduling",
    name: "Manage and Organize Personal Calendar",
    frequency: "Daily",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 30.4,
  },
  {
    id: "cs8",
    category: "Communication & Scheduling",
    name: "Set Reminders for Important Dates",
    frequency: "Monthly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 1.0,
  },
  {
    id: "cs9",
    category: "Communication & Scheduling",
    name: "Transcribe Voice Memos to Text/Tasks",
    frequency: "Weekly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 4.3,
  },
  {
    id: "cs10",
    category: "Communication & Scheduling",
    name: "Unsubscribe from Junk Email Lists",
    frequency: "Monthly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 2.0,
  },
  // Information Management & Research
  {
    id: "imr1",
    category: "Information Management & Research",
    name: "Create a Daily Personalized News Briefing",
    frequency: "Daily",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 30.4,
  },
  {
    id: "imr2",
    category: "Information Management & Research",
    name: "Summarize Long Articles, Reports, or Videos",
    frequency: "Weekly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 26.0,
  },
  {
    id: "imr3",
    category: "Information Management & Research",
    name: "Research and Compare Products for Purchase",
    frequency: "Weekly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 26.0,
  },
  {
    id: "imr4",
    category: "Information Management & Research",
    name: "Fact-Check Information Online",
    frequency: "Weekly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 8.7,
  },
  {
    id: "imr5",
    category: "Information Management & Research",
    name: "Compile Research for Personal or Work Projects",
    frequency: "Monthly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 12.0,
  },
  {
    id: "imr6",
    category: "Information Management & Research",
    name: "Find New Books/Podcasts Based on Interests",
    frequency: "Weekly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 4.3,
  },
  {
    id: "imr7",
    category: "Information Management & Research",
    name: "Track and Summarize Industry/Competitor News",
    frequency: "Weekly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 13.0,
  },
  {
    id: "imr8",
    category: "Information Management & Research",
    name: "Monitor Online Mentions of Name or Brand",
    frequency: "Daily",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 30.4,
  },
  {
    id: "imr9",
    category: "Information Management & Research",
    name: "Find and Vet Online Courses or Tutorials",
    frequency: "Monthly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 4.0,
  },
  {
    id: "imr10",
    category: "Information Management & Research",
    name: "Translate Text from a Foreign Language",
    frequency: "Monthly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 2.0,
  },
  // Home & Household
  {
    id: "hh1",
    category: "Home & Household",
    name: "Create a Weekly Meal Plan",
    frequency: "Weekly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 26.0,
  },
  {
    id: "hh2",
    category: "Home & Household",
    name: "Generate Grocery List Based on Meal Plan",
    frequency: "Weekly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 8.7,
  },
  {
    id: "hh3",
    category: "Home & Household",
    name: "Order Groceries for Delivery/Pickup",
    frequency: "Weekly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 34.7,
  },
  {
    id: "hh4",
    category: "Home & Household",
    name: "Find and Book Home Service Providers",
    frequency: "Annually",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 4.0,
  },
  {
    id: "hh5",
    category: "Home & Household",
    name: "Manage Smart Home Device Routines",
    frequency: "Weekly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 4.3,
  },
  {
    id: "hh6",
    category: "Home & Household",
    name: "Create and Manage a Family Chore Chart",
    frequency: "Weekly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 4.3,
  },
  {
    id: "hh7",
    category: "Home & Household",
    name: "Track Household Inventory (e.g., paper towels)",
    frequency: "Monthly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 2.0,
  },
  {
    id: "hh8",
    category: "Home & Household",
    name: "Find Recipes Based on Available Ingredients",
    frequency: "Weekly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 8.7,
  },
  {
    id: "hh9",
    category: "Home & Household",
    name: "Manage Package Deliveries and Returns",
    frequency: "Monthly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 3.0,
  },
  {
    id: "hh10",
    category: "Home & Household",
    name: "Set Home Maintenance Reminders",
    frequency: "Monthly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 1.0,
  },
  // Finance & Shopping
  {
    id: "fs1",
    category: "Finance & Shopping",
    name: "Track and Categorize Daily Expenses",
    frequency: "Daily",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 45.6,
  },
  {
    id: "fs2",
    category: "Finance & Shopping",
    name: "Generate Monthly Budget and Spending Reports",
    frequency: "Monthly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 6.0,
  },
  {
    id: "fs3",
    category: "Finance & Shopping",
    name: "Set Bill Payment Reminders",
    frequency: "Monthly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 2.0,
  },
  {
    id: "fs4",
    category: "Finance & Shopping",
    name: "Find Coupons and Discount Codes While Shopping",
    frequency: "Weekly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 13.0,
  },
  {
    id: "fs5",
    category: "Finance & Shopping",
    name: "Manage and Audit Subscription Services",
    frequency: "Monthly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 2.0,
  },
  {
    id: "fs6",
    category: "Finance & Shopping",
    name: "Initiate Routine Bank Transfers",
    frequency: "Monthly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 1.0,
  },
  {
    id: "fs7",
    category: "Finance & Shopping",
    name: "Compile and Organize Documents for Taxes",
    frequency: "Annually",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 10.0,
  },
  {
    id: "fs8",
    category: "Finance & Shopping",
    name: "Compare Insurance Quotes (Car, Home, Health)",
    frequency: "Annually",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 5.0,
  },
  {
    id: "fs9",
    category: "Finance & Shopping",
    name: "Track Loyalty Points and Rewards Programs",
    frequency: "Monthly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 1.0,
  },
  {
    id: "fs10",
    category: "Finance & Shopping",
    name: "Initiate Online Return and Refund Processes",
    frequency: "Monthly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 4.0,
  },
  // Health & Personal Development
  {
    id: "hpd1",
    category: "Health & Personal Development",
    name: "Schedule Workouts into Calendar",
    frequency: "Weekly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 4.3,
  },
  {
    id: "hpd2",
    category: "Health & Personal Development",
    name: "Find New Workout Routines or Fitness Classes",
    frequency: "Weekly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 8.7,
  },
  {
    id: "hpd3",
    category: "Health & Personal Development",
    name: "Track Daily Fitness and Health Metrics",
    frequency: "Daily",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 15.2,
  },
  {
    id: "hpd4",
    category: "Health & Personal Development",
    name: "Find and Schedule Doctor/Dentist Appointments",
    frequency: "Annually",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 2.0,
  },
  {
    id: "hpd5",
    category: "Health & Personal Development",
    name: "Set Daily Medication or Vitamin Reminders",
    frequency: "Daily",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 6.1,
  },
  {
    id: "hpd6",
    category: "Health & Personal Development",
    name: "Log Daily Meals for Calorie/Macro Tracking",
    frequency: "Daily",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 76.0,
  },
  {
    id: "hpd7",
    category: "Health & Personal Development",
    name: "Guide a Daily Meditation or Mindfulness Session",
    frequency: "Daily",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 12.2,
  },
  {
    id: "hpd8",
    category: "Health & Personal Development",
    name: "Summarize Key Takeaways from Books",
    frequency: "Weekly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 26.0,
  },
  {
    id: "hpd9",
    category: "Health & Personal Development",
    name: "Track Daily Water Intake",
    frequency: "Daily",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 6.1,
  },
  {
    id: "hpd10",
    category: "Health & Personal Development",
    name: "Find and Register for Volunteer Opportunities",
    frequency: "Monthly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 3.0,
  },
  // Travel & Leisure
  {
    id: "tl1",
    category: "Travel & Leisure",
    name: "Research and Propose Travel Destinations",
    frequency: "Monthly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 12.0,
  },
  {
    id: "tl2",
    category: "Travel & Leisure",
    name: "Find Best Deals on Flights and Accommodations",
    frequency: "Monthly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 12.0,
  },
  {
    id: "tl3",
    category: "Travel & Leisure",
    name: "Create a Detailed Travel Itinerary",
    frequency: "Annually",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 8.0,
  },
  {
    id: "tl4",
    category: "Travel & Leisure",
    name: "Book Flights, Hotels, and Rental Cars",
    frequency: "Annually",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 4.0,
  },
  {
    id: "tl5",
    category: "Travel & Leisure",
    name: "Find and Book Restaurants/Tours for a Trip",
    frequency: "Annually",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 6.0,
  },
  {
    id: "tl6",
    category: "Travel & Leisure",
    name: "Automatically Check-In to Flights",
    frequency: "Annually",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 0.5,
  },
  {
    id: "tl7",
    category: "Travel & Leisure",
    name: "Track Flight Status and Gate Changes in Real-Time",
    frequency: "Annually",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 1.0,
  },
  {
    id: "tl8",
    category: "Travel & Leisure",
    name: "Generate a Custom Packing List",
    frequency: "Annually",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 1.0,
  },
  {
    id: "tl9",
    category: "Travel & Leisure",
    name: "Find Local Events and Activities for the Weekend",
    frequency: "Weekly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 8.7,
  },
  {
    id: "tl10",
    category: "Travel & Leisure",
    name: "Book Tickets for Movies, Concerts, or Events",
    frequency: "Monthly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 2.0,
  },
  // Work & Professional Life
  {
    id: "wpl1",
    category: "Work & Professional Life",
    name: 'Prepare a Daily "Get to Work" Briefing',
    frequency: "Daily",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 21.7,
  },
  {
    id: "wpl2",
    category: "Work & Professional Life",
    name: "Take and Summarize Meeting Notes (via recording)",
    frequency: "Weekly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 26.0,
  },
  {
    id: "wpl3",
    category: "Work & Professional Life",
    name: "Create First Drafts of Reports or Presentations",
    frequency: "Weekly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 52.0,
  },
  {
    id: "wpl4",
    category: "Work & Professional Life",
    name: "Update CRM with Meeting Notes and Contacts",
    frequency: "Daily",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 43.3,
  },
  {
    id: "wpl5",
    category: "Work & Professional Life",
    name: "Automatically File Digital Documents",
    frequency: "Daily",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 21.7,
  },
  {
    id: "wpl6",
    category: "Work & Professional Life",
    name: "Prioritize Daily and Weekly To-Do Lists",
    frequency: "Daily",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 21.7,
  },
  {
    id: "wpl7",
    category: "Work & Professional Life",
    name: "Track Work Hours and Generate Timesheets",
    frequency: "Weekly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 8.7,
  },
  {
    id: "wpl8",
    category: "Work & Professional Life",
    name: "Proofread and Format Documents",
    frequency: "Weekly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 17.3,
  },
  {
    id: "wpl9",
    category: "Work & Professional Life",
    name: "Draft Routine Work Communications (e.g., Slack)",
    frequency: "Daily",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 43.3,
  },
  {
    id: "wpl10",
    category: "Work & Professional Life",
    name: "Schedule Social Media Posts",
    frequency: "Weekly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 13.0,
  },
  // Social & Family Life
  {
    id: "sfl1",
    category: "Social & Family Life",
    name: "Plan and Organize Social Events/Parties",
    frequency: "Monthly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 12.0,
  },
  {
    id: "sfl2",
    category: "Social & Family Life",
    name: "Draft Personalized Birthday/Anniversary Messages",
    frequency: "Weekly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 4.3,
  },
  {
    id: "sfl3",
    category: "Social & Family Life",
    name: "Research and Purchase Gifts",
    frequency: "Monthly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 12.0,
  },
  {
    id: "sfl4",
    category: "Social & Family Life",
    name: "Schedule and Send Invites for Family Video Calls",
    frequency: "Weekly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 4.3,
  },
  {
    id: "sfl5",
    category: "Social & Family Life",
    name: 'Compile a Weekly "Family Highlights" Journal',
    frequency: "Weekly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 8.7,
  },
  {
    id: "sfl6",
    category: "Social & Family Life",
    name: "Find and Vet Kid-Friendly Activities or Camps",
    frequency: "Monthly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 6.0,
  },
  {
    id: "sfl7",
    category: "Social & Family Life",
    name: "Manage and Sync the Family Calendar",
    frequency: "Daily",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 30.4,
  },
  {
    id: "sfl8",
    category: "Social & Family Life",
    name: "Coordinate Group Gifts or Potlucks",
    frequency: "Annually",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 5.0,
  },
  {
    id: "sfl9",
    category: "Social & Family Life",
    name: "Respond to RSVPs for Events",
    frequency: "Weekly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 2.2,
  },
  {
    id: "sfl10",
    category: "Social & Family Life",
    name: "Find and Vet a Babysitter or Pet Sitter",
    frequency: "Monthly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 4.0,
  },
  // Creative & Advanced Tasks
  {
    id: "cat1",
    category: "Creative & Advanced Tasks",
    name: "Brainstorm Ideas for Creative Projects",
    frequency: "Monthly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 5.0,
  },
  {
    id: "cat2",
    category: "Creative & Advanced Tasks",
    name: "Generate Basic Code Snippets or Formulas",
    frequency: "Weekly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 17.3,
  },
  {
    id: "cat3",
    category: "Creative & Advanced Tasks",
    name: "Help Debug Simple Code or Scripts",
    frequency: "Weekly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 26.0,
  },
  {
    id: "cat4",
    category: "Creative & Advanced Tasks",
    name: "Suggest Ways to Use Leftover Food Ingredients",
    frequency: "Weekly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 4.3,
  },
  {
    id: "cat5",
    category: "Creative & Advanced Tasks",
    name: "Create Personalized Bedtime Stories for Kids",
    frequency: "Daily",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 30.4,
  },
  {
    id: "cat6",
    category: "Creative & Advanced Tasks",
    name: "Suggest and Outline Weekend DIY Projects",
    frequency: "Weekly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 4.3,
  },
  {
    id: "cat7",
    category: "Creative & Advanced Tasks",
    name: "Act as a Language Practice Partner",
    frequency: "Daily",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 60.8,
  },
  {
    id: "cat8",
    category: "Creative & Advanced Tasks",
    name: 'Generate "Staycation" Itineraries',
    frequency: "Annually",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 3.0,
  },
  {
    id: "cat9",
    category: "Creative & Advanced Tasks",
    name: "Create Adaptive Workout Plans Based on Progress",
    frequency: "Weekly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 8.7,
  },
  {
    id: "cat10",
    category: "Creative & Advanced Tasks",
    name: "Generate Drafts for Personal Blog or Social Media",
    frequency: "Weekly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 26.0,
  },
  // Miscellaneous & Niche Tasks
  {
    id: "mnt1",
    category: "Miscellaneous & Niche Tasks",
    name: "Manage and Update a Personal Website",
    frequency: "Monthly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 6.0,
  },
  {
    id: "mnt2",
    category: "Miscellaneous & Niche Tasks",
    name: "Track Car Maintenance Schedules and Recalls",
    frequency: "Annually",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 1.0,
  },
  {
    id: "mnt3",
    category: "Miscellaneous & Niche Tasks",
    name: "Research New Apartments or Homes",
    frequency: "Annually",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 20.0,
  },
  {
    id: "mnt4",
    category: "Miscellaneous & Niche Tasks",
    name: "Manage Pet Vaccination/Vet Appointments",
    frequency: "Annually",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 1.5,
  },
  {
    id: "mnt5",
    category: "Miscellaneous & Niche Tasks",
    name: 'Curate a "Learning Queue" of Articles/Videos',
    frequency: "Weekly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 4.3,
  },
  {
    id: "mnt6",
    category: "Miscellaneous & Niche Tasks",
    name: "Find and Tailor Resumes for Job Applications",
    frequency: "Annually",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 15.0,
  },
  {
    id: "mnt7",
    category: "Miscellaneous & Niche Tasks",
    name: "Track Food Expiration Dates in Pantry/Fridge",
    frequency: "Weekly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 8.7,
  },
  {
    id: "mnt8",
    category: "Miscellaneous & Niche Tasks",
    name: 'Manage and Summarize a "Read-it-Later" Queue',
    frequency: "Weekly",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 13.0,
  },
  {
    id: "mnt9",
    category: "Miscellaneous & Niche Tasks",
    name: "Draft Letters to Contest Incorrect Bills",
    frequency: "Annually",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 2.0,
  },
  {
    id: "mnt10",
    category: "Miscellaneous & Niche Tasks",
    name: "Consolidate Key Info into a Single Daily Brief",
    frequency: "Daily",
    cost: "$0 (Part of AI Subscription)",
    timeSaved: 30.4,
  },
]
